import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payablebalace-popover',
  templateUrl: './payablebalace-popover.page.html',
  styleUrls: ['./payablebalace-popover.page.scss'],
})
export class PayablebalacePopoverPage implements OnInit {
  @Input() bonusallowed : any
  constructor() { }

  ngOnInit() {
    console.log(this.bonusallowed)
  }

}
